<template>
  <b-container v-if="page === 'LIST_TEMPLATE'" data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
              "public.views.Pages.Patient.Account.HistoricClinic.contact.titleList"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction></template>
      <template v-slot:body>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
            <template slot="label">
              <div class="search-datatable">
                <i class="fas fa-search fa-fw"></i>
                {{
                  $t(
                    "public.views.Pages.Patient.Account.HistoricClinic.contact.search"
                  )
                }}
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-data-table :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'fas fa-arrow-left',
              lastIcon: 'fas fa-arrow-right',
              prevIcon: 'fas fa-minus',
              nextIcon: 'fas fa-plus',
              'items-per-page-options': [10, 25, 50],
            }" :headers="headers" :items="templates" :items-per-page="10" :search="search" item-key="id">
          <template v-slot:item.professional="{ item }">
            <div v-if="item.professional">
              {{ item.professional.name }} {{ item.professional.lastname }}
            </div>
          </template>
          <template v-slot:item.uuid="{ item }">
            <div class="div-table-data">
              <button :id="'btnSee' + item.id" class="item" v-on:click="getHistoricStore(item.id)">
                <i class="ri-eye-line"></i>
              </button>
              <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
                <template #title>{{
                  $t(
                    "public.views.Pages.Patient.Account.HistoricClinic.contact.seeHistoricClinic"
                  )
                }}
                </template>
              </b-popover>
            </div>
          </template>
        </v-data-table>
      </template>
    </iq-card>
  </b-container>
  <b-container v-else fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
              "public.views.Pages.Patient.Account.HistoricClinic.contact.titleComplete"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="listTemplate">{{
          $t(
            "public.views.Pages.Patient.Account.HistoricClinic.contact.btnBack"
          )
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div v-if="historicStore &&
            historicStore.historics &&
            historicStore.historics.length !== 0
            ">
          <div v-for="(item, index) in historicStore.historics" v-bind:key="index">
            <tab-nav :tabs="true">
              <tab-nav-items v-for="(option, index) in item.tabs" :id="'tab-nav-' + index" :key="index"
                :active="index < 1" :ariaSelected="true" :href="'#tab-' + index" role="tab">
                <template v-slot:title>
                  {{ option.name }}
                </template>
              </tab-nav-items>
            </tab-nav>
            <tab-content>
              <tab-content-item v-for="(option, index) in item.tabs" :id="'tab-' + index" :key="index"
                :active="index < 1">
                <div class="test-survey-builder">
                  <b-row>
                    <b-col v-for="(question, index) in option.questionsList" :key="index"
                      :cols="item.numCol === null ? 12 : item.numCol">
                      <div class="border p-3">
                        <div class="question-section">
                          <p class="question_body">{{ question.body }}</p>
                        </div>
                        <div class="answer-section">
                          <div v-if="question.type === 'BOOLEAN'" class="option-section">
                            <b-form-group v-slot="{ ariaDescribedby }">
                              <b-form-radio v-for="(option, index) in question.options" :key="index"
                                v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                                :name="'booleanSelect' + question.uuid" :value="option.sequence">{{ option.body }}
                              </b-form-radio>
                            </b-form-group>
                          </div>
                          <div v-if="question.type === 'TEXT'" class="option-section">
                            <b-form-input v-if="question.characterLimited" v-model="question.value"
                              :maxlength="question.textLimit" :readonly="readOnly" min="0" type="text" />
                            <b-form-input v-if="!question.characterLimited" v-model="question.value" :readonly="readOnly"
                              type="text" />
                          </div>
                          <div v-if="question.type === 'FILE'" class="option-section">
                            <vue-dropzone :id="'dropzone' + question.uuid" :options="dropzoneOptions" @vdropzone-success="
                              vdropzoneSuccess(question, ...arguments)
                              "></vue-dropzone>
                          </div>
                          <div v-if="question.type === 'RATING'" class="option-section">
                            <b-form-rating :id="'rating' + question.uuid" v-model="question.value"
                              variant="warning"></b-form-rating>
                          </div>
                          <div v-if="question.type === 'DATE'" class="option-section">
                            <date-picker v-model="question.valueTmp" :format="myFormat" :formatter="momentFormat"
                              :readonly="readOnly" type="date" @pick="updateDate(question)"></date-picker>
                          </div>
                          <div v-if="question.type === 'TIME'" class="option-section">
                            <vue-timepicker v-model="question.valueTmp" :readonly="readOnly"
                              @change="updateTime(question)"></vue-timepicker>
                          </div>
                          <div v-if="question.type === 'NUMBER'" class="option-section">
                            <div>
                              <b-form-input v-if="question.hasMinMax && !question.allowDecimals
                                " v-model="question.value" :max="question.maxValue" :min="question.minValue"
                                :readonly="readOnly" type="range">
                                {{ question.value }}
                              </b-form-input>
                              <b-form-input v-if="!question.hasMinMax && question.allowDecimals
                                " v-model="question.value" :readonly="readOnly" step="0.01" type="number">
                              </b-form-input>
                              <b-form-input v-if="!question.hasMinMax && !question.allowDecimals
                                " v-model="question.value" :readonly="readOnly" type="number">
                              </b-form-input>
                              <b-form-input v-if="question.hasMinMax && question.allowDecimals
                                " v-model="question.value" :max="question.maxValue" :min="question.minValue"
                                :readonly="readOnly" step="0.01" type="range">
                              </b-form-input>
                              <div v-if="question.hasMinMax">
                                {{ question.value }}
                              </div>
                            </div>
                          </div>
                          <div v-if="question.type === 'SINGLE_CHOICE'" class="option-section">
                            <b-form-group v-slot="{ ariaDescribedby }">
                              <b-form-radio v-for="(option, index) in question.options" :key="index"
                                v-model="question.value" :aria-describedby="ariaDescribedby" :disabled="readOnly"
                                :value="option.body" name="singleSelect">{{ option.body }}
                              </b-form-radio>
                            </b-form-group>
                          </div>
                        </div>
                        <div v-if="question.type === 'TEXTAREA'" class="option-section">
                          <b-form-textarea :id="'textarea' + question.uuid" v-model="question.value" max-rows="6"
                            rows="3"></b-form-textarea>
                        </div>
                        <div v-if="question.type === 'EDITOR'" class="option-section">
                          <ckeditor :id="'ckeditor' + question.uuid" v-model="question.value" :config="configCK"
                            type="classic"></ckeditor>
                        </div>
                        <div v-if="question.type === 'MULTI_CHOICE'" class="option-section">
                          <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group v-model="question.valueTmp"
                              @input="multiChoiceTransformJson(question)">
                              <b-form-checkbox v-for="(option, index) in question.options" :key="index"
                                :aria-describedby="ariaDescribedby" :name="'multiChoiceSelect' + question.uuid"
                                :value="option.sequence">{{ option.body }}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </tab-content-item>
            </tab-content>
          </div>
        </div>

        <div v-else>
          <b-alert show variant="warning">{{
            $t(
              "public.views.Pages.Patient.Account.HistoricClinic.contact.alert"
            )
          }}
          </b-alert>
        </div>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i>
          {{
            $t(
              "public.views.Pages.Patient.Account.HistoricClinic.contact.titleCompleteNotes"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
      </template>
      <template v-slot:body>
        <b-card-group deck>
          <b-col>
            <b-row v-for="(note, index) in notes" :key="index">
              <b-card bg-variant="warning" class="text-center mt-4" text-variant="black">
                <template #header>
                  <h6 class="mb-0">
                    <div v-if="note.professional">
                      <b-avatar size="2em" v-bind:src="note.professional.avatar"></b-avatar>
                      {{ note.professional.name }}
                      {{ note.professional.lastname }}
                    </div>
                    <p class="font-size-12 mt-2">
                      {{
                        note.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm")
                      }}
                    </p>
                  </h6>
                </template>
                <b-card-text class="max-heigh-card-notes" v-html="note.content"></b-card-text>
              </b-card>
            </b-row>
          </b-col>
        </b-card-group>
      </template>
    </iq-card>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import moment from "moment";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

import SurveyBuilder from "../../../../components/survey/SurveyBuilder";
import QuestionsView from "../../../../components/survey/QuestionsView";

import patientService from "../../../../services/patient";

import utilsService from "../../../../services/utils";
import historicService from "../../../../services/historic";

export default {
  name: "HistoricClinics",

  mounted() {
    xray.index();
    this.getAllHistoricsStore();
    this.$root.$on("add-update-question", (q, tab) => {
      this.updateQuestionsList(q, tab);
    });
    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_HISTORIC_CLINIC", info: "" });
  },
  components: {
    SurveyBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
    DatePicker,
    VueTimepicker,
  },
  computed: {},
  methods: {
    async getAllNotes(historicStoreId) {
      let self = this;

      historicService
        .getNotesByHistoricStoreSecure(historicStoreId)
        .then((response) => {
          if (response) {
            self.notes = response.data;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "historicService.getNotesByHistoricStore",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              historicStoreId: historicStoreId
            })
          });
        });
    },
    multiChoiceTransformJson(question) {
      if (question.valueTmp && question.type === "MULTI_CHOICE") {
        question.value = JSON.stringify(question.valueTmp);
      }
    },
    updateTime(question) {
      if (question.valueTmp) {
        question.value = question.valueTmp.HH + ":" + question.valueTmp.mm;
      }
    },
    updateDate(question) {
      question.value = moment(question.valueTmp).format("DD/MM/yyyy");
    },
    vdropzoneSuccess: function (question, file, response) {
      question.value = response.uuid;
    },
    notFirst() {
      this.isFirstRun = false;
    },
    listTemplate() {
      this.page = "LIST_TEMPLATE";
      this.getAllHistoricsStore();
    },
    viewComplete() {
      this.cleanCreate();
      this.action = "COMPLETE";
      this.page = "TEMPLATE";
    },
    cleanCreateByTemplate() {
      this.template = "";
      this.validatorStep2.errors = [];
    },
    cleanCreate() {
      this.patient = "";
      this.name = "";
      this.validatorStep1.errors = [];
    },
    initForm() {
      let self = this;
      if (self.historicStore.historics) {
        self.historicStore.historics.forEach(function (historic) {
          if (historic.tabs) {
            historic.tabs.forEach(function (tab) {
              if (tab.questionsList) {
                tab.questionsList.forEach(function (question) {
                  if (question.type === "DATE") {
                    question.valueTmp = moment(
                      question.value,
                      "DD/MM/YYYY"
                    ).toDate();
                  }
                });
              }
            });
          }
        });
      }
    },
    getHistoricStore(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.findHistoricsStore(localStorage.getItem("userId"), id),
        (response) => {
          if (response) {
            self.idHistoricStore = id;
            self.historicStore = response.data;

            self.getAllNotes(id);

            self.initForm();

            self.viewComplete();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.findHistoricsStore",
            module: "view-pages-patient-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId"), id: id
            })
          });
        },
        " "
      );
    },
    getAllHistoricsStore() {
      let self = this;

      this.$awn.asyncBlock(
        patientService.getAllHistoricsStore(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.templates = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.getAllHistoricsStore",
            module: "view-pages-patient-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
  },

  data() {
    return {
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },
      readOnly: true,
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },

      disabled: true,
      isFirstRun: true,

      search: "",
      action: "",
      page: "LIST_TEMPLATE",
      validatorStep1: validator,
      validatorStep2: validator,
      tabs: [],
      name: "",
      uuid: "",
      patient: localStorage.getItem("userId"),
      addQuestion: false,

      templates: [],
      notes: [],

      template: "",

      idHistoricStore: "",

      historicStore: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Account.HistoricClinic.contact.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Account.HistoricClinic.contact.professional"
          ),
          value: "professional",
        },
        { text: "", value: "uuid" },
      ],
    };
  },
};
</script>
